module.exports = __webpack_public_path__ + "img/焦云立.dfc6a055.jpg";